export interface Category {
  name: string;
  desc: string;
  count: string;
  color: string;
  image: string;
}

export interface Comic {
  title: string;
  tag: string;
  author: string;
  episodes: string;
  score: string;
  trend: string;
  image: string;
}

export interface Feature {
  icon: string;
  title: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  text: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const heroPhoneImage =
  "https://readdy.ai/api/search-image?query=vertical%20smartphone%20screenshot%20of%20a%20colorful%20comic%20reading%20app%20showing%20bright%20manga%20panels%2C%20warm%20banana%20yellow%20and%20coral%20orange%20comic%20artwork%2C%20clean%20minimal%20app%20interface%20with%20reading%20progress%20bar%20at%20bottom%2C%20vibrant%20playful%20illustration%20style&width=560&height=760&seq=banana-hero-phone&orientation=portrait";

export const heroPosterImage =
  "https://readdy.ai/api/search-image?query=playful%20comic%20poster%20art%20of%20an%20energetic%20manga%20hero%20flying%20through%20a%20banana%20yellow%20sky%2C%20bold%20clean%20shapes%2C%20warm%20orange%20and%20yellow%20palette%2C%20youthful%20action%20illustration%2C%20high%20contrast%2C%20editorial%20comic%20cover%20style&width=420&height=600&seq=banana-hero-poster&orientation=portrait";

export const categories: Category[] = [
  {
    name: "热血冒险",
    desc: "燃到不行的战斗与冒险故事",
    count: "2.3万部",
    color: "from-primary-400 to-accent-400",
    image:
      "https://readdy.ai/api/search-image?query=energetic%20manga%20comic%20cover%20art%20of%20a%20young%20hero%20with%20sword%20in%20battle%20pose%2C%20dynamic%20action%2C%20warm%20yellow%20orange%20background%2C%20bold%20clean%20comic%20style%2C%20youthful%20and%20vibrant&width=400&height=520&seq=banana-cat-hotblood&orientation=portrait",
  },
  {
    name: "恋爱校园",
    desc: "甜甜的校园青春恋爱物语",
    count: "1.8万部",
    color: "from-secondary-400 to-primary-400",
    image:
      "https://readdy.ai/api/search-image?query=romantic%20manga%20comic%20cover%20of%20a%20school%20boy%20and%20girl%20under%20cherry%20blossoms%2C%20sweet%20soft%20youthful%20illustration%2C%20warm%20coral%20and%20yellow%20tones%2C%20clean%20comic%20style%2C%20romance%20genre&width=400&height=520&seq=banana-cat-love&orientation=portrait",
  },
  {
    name: "悬疑推理",
    desc: "烧脑反转，层层揭开真相",
    count: "9600部",
    color: "from-accent-400 to-foreground-500",
    image:
      "https://readdy.ai/api/search-image?query=mystery%20manga%20comic%20cover%20of%20a%20detective%20silhouette%20with%20magnifying%20glass%20and%20shadows%2C%20intriguing%20noir%20atmosphere%20with%20warm%20amber%20accents%2C%20clean%20bold%20comic%20style%2C%20suspense&width=400&height=520&seq=banana-cat-mystery&orientation=portrait",
  },
  {
    name: "玄幻仙侠",
    desc: "御剑修行，踏破九重天",
    count: "1.2万部",
    color: "from-primary-500 to-secondary-400",
    image:
      "https://readdy.ai/api/search-image?query=wuxia%20xianxia%20manga%20cover%20of%20a%20sword%20cultivator%20floating%20above%20cloudy%20peaks%2C%20flying%20swords%2C%20warm%20golden%20orange%20sunset%20palette%2C%20epic%20clean%20comic%20illustration&width=400&height=520&seq=banana-cat-xianxia&orientation=portrait",
  },
  {
    name: "搞笑日常",
    desc: "爆笑不断，轻松解压神器",
    count: "1.5万部",
    color: "from-accent-400 to-primary-300",
    image:
      "https://readdy.ai/api/search-image?query=comedy%20manga%20cover%20of%20a%20goofy%20cute%20banana%20character%20with%20funny%20exaggerated%20expression%2C%20bright%20playful%20colors%2C%20warm%20yellow%20background%2C%20clean%20chibi%20comic%20style%2C%20humorous&width=400&height=520&seq=banana-cat-comedy&orientation=portrait",
  },
  {
    name: "科幻星际",
    desc: "星辰大海，硬核科幻脑洞",
    count: "7800部",
    color: "from-secondary-500 to-accent-400",
    image:
      "https://readdy.ai/api/search-image?query=sci-fi%20manga%20cover%20of%20a%20space%20adventurer%20standing%20before%20a%20glowing%20spaceship%20and%20planets%2C%20warm%20sunset%20nebula%20in%20orange%20and%20teal%2C%20clean%20bold%20comic%20style%2C%20epic%20science%20fiction&width=400&height=520&seq=banana-cat-scifi&orientation=portrait",
  },
  {
    name: "奇幻异世界",
    desc: "穿越冒险，开启全新人生",
    count: "1.1万部",
    color: "from-primary-400 to-secondary-500",
    image:
      "https://readdy.ai/api/search-image?query=fantasy%20isekai%20manga%20cover%20of%20a%20young%20adventurer%20in%20a%20magical%20floating%20world%20with%20dragon%20and%20castles%2C%20warm%20golden%20light%2C%20colorful%20clean%20comic%20illustration%2C%20adventure&width=400&height=520&seq=banana-cat-isekai&orientation=portrait",
  },
  {
    name: "都市成长",
    desc: "职场打拼，都市人生百态",
    count: "8900部",
    color: "from-accent-500 to-primary-400",
    image:
      "https://readdy.ai/api/search-image?query=urban%20manga%20cover%20of%20a%20confident%20young%20professional%20walking%20through%20a%20warm%20city%20street%20at%20sunset%2C%20towering%20buildings%2C%20warm%20orange%20yellow%20palette%2C%20clean%20comic%20style%2C%20growth%20and%20career%20theme&width=400&height=520&seq=banana-cat-urban&orientation=portrait",
  },
];

export const popularComics: Comic[] = [
  {
    title: "星际救援队",
    tag: "科幻星际",
    author: "宇宙捕手",
    episodes: "更新至 342 话",
    score: "9.2",
    trend: "+12%",
    image:
      "https://readdy.ai/api/search-image?query=sci-fi%20space%20rescue%20team%20manga%20cover%20with%20astronaut%20heroes%20and%20a%20shining%20spaceship%2C%20warm%20orange%20nebula%20sky%2C%20clean%20bold%20comic%20style%2C%20youthful%20epic&width=360&height=500&seq=banana-pop-1&orientation=portrait",
  },
  {
    title: "月影侦探社",
    tag: "悬疑推理",
    author: "夜猫侦探",
    episodes: "更新至 128 话",
    score: "9.0",
    trend: "+8%",
    image:
      "https://readdy.ai/api/search-image?query=noir%20detective%20manga%20cover%20of%20two%20young%20detectives%20under%20moonlight%20in%20a%20rainy%20city%2C%20warm%20amber%20lamp%20light%2C%20clean%20bold%20comic%20style%2C%20mystery&width=360&height=500&seq=banana-pop-2&orientation=portrait",
  },
  {
    title: "元气少女日记",
    tag: "恋爱校园",
    author: "草莓汽水",
    episodes: "更新至 256 话",
    score: "9.4",
    trend: "+15%",
    image:
      "https://readdy.ai/api/search-image?query=cheerful%20schoolgirl%20diary%20manga%20cover%20with%20a%20happy%20girl%20with%20notebook%20and%20cherry%20blossoms%2C%20warm%20coral%20yellow%20palette%2C%20clean%20cute%20comic%20style%2C%20youthful&width=360&height=500&seq=banana-pop-3&orientation=portrait",
  },
  {
    title: "玄幻·御剑行",
    tag: "玄幻仙侠",
    author: "青云客",
    episodes: "更新至 410 话",
    score: "9.1",
    trend: "+10%",
    image:
      "https://readdy.ai/api/search-image?query=xianxia%20sword%20cultivator%20manga%20cover%20flying%20on%20a%20sword%20above%20clouds%2C%20warm%20golden%20sunrise%2C%20epic%20clean%20comic%20style%2C%20flying%20sword%20martial%20arts&width=360&height=500&seq=banana-pop-4&orientation=portrait",
  },
  {
    title: "山海异兽录",
    tag: "热血冒险",
    author: "山海工坊",
    episodes: "更新至 198 话",
    score: "8.9",
    trend: "+9%",
    image:
      "https://readdy.ai/api/search-image?query=mythical%20beast%20bestiary%20manga%20cover%20with%20a%20young%20hero%20and%20legendary%20animals%2C%20warm%20orange%20and%20gold%20palette%2C%20clean%20bold%20comic%20style%2C%20adventure&width=360&height=500&seq=banana-pop-5&orientation=portrait",
  },
  {
    title: "都市异能觉醒",
    tag: "都市成长",
    author: "凌晨四点",
    episodes: "更新至 175 话",
    score: "9.3",
    trend: "+18%",
    image:
      "https://readdy.ai/api/search-image?query=urban%20superpower%20manga%20cover%20of%20a%20young%20man%20with%20glowing%20energy%20in%20a%20modern%20city%20at%20sunset%2C%20warm%20orange%20yellow%20tones%2C%20clean%20comic%20style%2C%20urban%20fantasy&width=360&height=500&seq=banana-pop-6&orientation=portrait",
  },
  {
    title: "异世界食堂物语",
    tag: "奇幻异世界",
    author: "暖心大厨",
    episodes: "更新至 220 话",
    score: "8.8",
    trend: "+7%",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20isekai%20restaurant%20manga%20cover%20with%20a%20chef%20serving%20steaming%20food%20to%20fantasy%20guests%2C%20warm%20golden%20warm%20light%2C%20clean%20cute%20comic%20style%2C%20heartwarming&width=360&height=500&seq=banana-pop-7&orientation=portrait",
  },
  {
    title: "搞笑社团大作战",
    tag: "搞笑日常",
    author: "香蕉小分队",
    episodes: "更新至 300 话",
    score: "9.5",
    trend: "+20%",
    image:
      "https://readdy.ai/api/search-image?query=hilarious%20school%20club%20comedy%20manga%20cover%20with%20a%20group%20of%20goofy%20students%20and%20a%20cute%20banana%20mascot%2C%20bright%20warm%20yellow%20palette%2C%20clean%20chibi%20comic%20style%2C%20fun&width=360&height=500&seq=banana-pop-8&orientation=portrait",
  },
];

export const features: Feature[] = [
  {
    icon: "ri-cloud-off-line",
    title: "离线阅读",
    desc: "把喜欢的漫画一键下载到本地，没网也能畅快追更，通勤地铁、深山旅行都能随行阅读。",
  },
  {
    icon: "ri-download-2-line",
    title: "智能缓存",
    desc: "自动预读下一话内容，滑动即翻页不卡顿，高清画质搭配流畅缓存，阅读体验更顺滑。",
  },
  {
    icon: "ri-bookmark-line",
    title: "订阅收藏",
    desc: "订阅连载自动追更、收藏喜爱的作品，新章节上线第一时间提醒，再也不怕错过更新。",
  },
  {
    icon: "ri-mac-line",
    title: "电脑版同步",
    desc: "香蕉漫画电脑版大屏看漫画更过瘾，支持跨设备云端同步阅读进度，换设备无缝衔接。",
  },
  {
    icon: "ri-smartphone-line",
    title: "手机版体验",
    desc: "为手机深度优化竖屏阅读，单手翻页、自动分格，香蕉漫画手机版随时随地想看就看。",
  },
  {
    icon: "ri-shield-star-line",
    title: "高清无广告",
    desc: "精选正版高清画质，纯净阅读界面减少干扰，让你专注享受每一帧画面带来的快乐。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿杰",
    role: "热血漫重度读者",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20young%20asian%20man%20portrait%20avatar%2C%20warm%20smile%2C%20flat%20clean%20illustration%20style%2C%20warm%20background&width=120&height=120&seq=banana-ava-1&orientation=squarish",
    text: "离线阅读太香了，地铁上没信号也能一路看完最新话，香蕉漫画是真的懂追更人的痛。",
  },
  {
    name: "小鹿",
    role: "恋爱漫爱好者",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20young%20asian%20woman%20portrait%20avatar%2C%20warm%20gentle%20smile%2C%20flat%20clean%20illustration%20style%2C%20warm%20coral%20background&width=120&height=120&seq=banana-ava-2&orientation=squarish",
    text: "订阅收藏功能很方便，更新的漫画会自动提醒，收藏夹整整齐齐，翻起来特别治愈。",
  },
  {
    name: "老白",
    role: "电脑版用户",
    avatar: "https://readdy.ai/api/search-image?query=relaxed%20adult%20asian%20man%20portrait%20avatar%20with%20glasses%2C%20flat%20clean%20illustration%20style%2C%20warm%20teal%20background&width=120&height=120&seq=banana-ava-3&orientation=squarish",
    text: "用电脑版大屏看漫画特别舒服，进度还能和手机同步，白天电脑晚上手机，完全无感切换。",
  },
  {
    name: "桃子",
    role: "缓存大户",
    avatar: "https://readdy.ai/api/search-image?query=cheerful%20young%20asian%20woman%20portrait%20avatar%20with%20ponytail%2C%20flat%20clean%20illustration%20style%2C%20warm%20yellow%20background&width=120&height=120&seq=banana-ava-4&orientation=squarish",
    text: "智能缓存很贴心，自动预载下一话，翻页从来不卡，高清画质看着特别舒服。",
  },
];

export const faqs: Faq[] = [
  {
    q: "香蕉漫画APP在哪里可以下载？",
    a: "你可以在香蕉漫画网首页点击“下载APP”按钮，根据你的设备选择安卓版或苹果版下载安装。下载后即可开始离线阅读与订阅收藏。",
  },
  {
    q: "香蕉漫画支持电脑版和手机版吗？",
    a: "支持。香蕉漫画同时提供电脑版与手机版，两者使用同一账号登录，阅读进度和订阅收藏会自动云端同步，换设备也能无缝衔接。",
  },
  {
    q: "离线阅读功能怎么使用？",
    a: "在漫画详情页点击“下载”即可将章节缓存到本地，下载完成后即使没有网络也能随时阅读。你可以在“我的下载”中管理已缓存的漫画。",
  },
  {
    q: "缓存功能会自动更新最新章节吗？",
    a: "智能缓存会按你的阅读习惯自动预读下一话。对于已订阅的连载作品，新章节上线后会及时提醒你下载更新，不错过任何更新。",
  },
  {
    q: "订阅和收藏有什么区别？",
    a: "订阅用于跟踪连载作品，新章节更新会自动提醒；收藏则用于整理你喜欢的作品清单，方便日后快速找到并继续阅读，两者可同时使用。",
  },
  {
    q: "在手机和电脑之间切换时进度会丢失吗？",
    a: "不会。只要使用同一账号登录，阅读进度、订阅与收藏都会实时云端同步，在手机和电脑之间切换时无缝衔接，进度不会丢失。",
  },
];